// The referral template (and specialty) last used for a letter, remembered in
// this browser per account, so the next letter starts there. Storage can be
// unavailable (private mode): then the dialog starts on the default template.
const KEY = "rosc:referralLetter";
type Account = string | null | undefined;
export type ReferralLastUsed = { templateId?: string; specialty?: string };
const keyFor = (account: Account): string =>
  account ? `${KEY}:${account}` : KEY;

export const readReferralLastUsed = (account: Account): ReferralLastUsed => {
  try {
    const value: unknown = JSON.parse(
      window.localStorage.getItem(keyFor(account)) ?? "null",
    );
    if (typeof value !== "object" || value === null) return {};
    const { templateId, specialty } = value as Record<string, unknown>;
    return {
      ...(typeof templateId === "string" && templateId.length <= 64
        ? { templateId }
        : {}),
      ...(typeof specialty === "string" && specialty.length <= 120
        ? { specialty }
        : {}),
    };
  } catch {
    return {};
  }
};

export const rememberReferralLastUsed = (
  account: Account,
  value: ReferralLastUsed,
): void => {
  try {
    window.localStorage.setItem(keyFor(account), JSON.stringify(value));
  } catch {
    // A convenience only.
  }
};
